import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

/**
 * CgEmissionFactorDisclaimer - Note shown wherever a default emission factor
 * with `disclaimerRequired: true` is displayed.
 *
 * Some rows of the EU Commission's default-values document contain a
 * calculation error: the printed total SEE does not equal the sum of the
 * row's own direct + indirect values. For those factors the platform shows
 * the corrected sum instead of the printed total, and this note explains
 * the discrepancy next to the value.
 */
export default function CgEmissionFactorDisclaimer({ className = '' }) {
  return (
    <div
      className={`flex items-start gap-1.5 rounded border border-amber-200 bg-amber-50 p-2 ${className}`.trim()}
    >
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        className="mt-0.5 text-amber-500"
        size="sm"
      />
      <span className="text-xs leading-snug text-amber-800">
        <span className="font-medium">Corrected total.</span> This total differs from the value
        printed in the EU Commission&apos;s regulation document, where the published total does not
        equal the sum of its own direct and indirect values due to a calculation error in the
        original document. The platform shows the corrected sum (direct + indirect) rather than
        carry the incorrect published figure into your calculations.
      </span>
    </div>
  );
}
